import { Store, select } from '@ngrx/store';
import { LoadSchool } from './../../../store/actions/school-actions';
import { take, tap, switchMap, filter } from 'rxjs/operators';
import { getSchoolLoadedStatus, getSchool, getSchoolLoadingStatus } from './../../../store/selectors/school-selectors';
import { Observable, of, combineLatest } from 'rxjs';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ISchool } from '../../../shared/typings/interfaces/school.interface';
import { UrlNavigationService } from 'Src/ng2/shared/services/url-navigation/url-navigation.service';
import { UrlPathService } from 'Src/ng2/shared/services/url-path-service/url-path.service';

@Injectable()
export class KimsTrackerAccessGuard implements CanActivate {
  constructor (private router: Router, private store: Store<any>, private urlPathService: UrlPathService) { }

  getSchoolFromStoreOrAPI (schoolId: string): Observable<ISchool> {
    return combineLatest([
      this.store.pipe(select(getSchoolLoadedStatus)),
      this.store.pipe(select(getSchoolLoadingStatus)),
    ]).pipe(
      tap(([loaded, loading]) => {
        if (!loaded && !loading) this.store.dispatch(new LoadSchool(schoolId));
      }),
      filter(([loaded]) => !!loaded),
      switchMap(() => this.store.pipe(select(getSchool))),
      take(1),
    );
  }

  canActivate (snapshot: ActivatedRouteSnapshot): Observable<UrlTree | boolean> {
    const schoolId = UrlNavigationService.getEntityId(snapshot);

    return this.getSchoolFromStoreOrAPI(schoolId).pipe(
      switchMap(school => {
        if (!school?.hasCurrentOrPriorFrnycKims) {
          const url = this.urlPathService.computeDistrictUrlPath(`/school/${schoolId}/home`);
          return of(this.router.createUrlTree([url]));
        } else return of(true) as Observable<boolean>;
      }),
    );
  }
}
